// extracted by mini-css-extract-plugin
export default {"button":"InStoreFraming_button__zLoA8","banner":"InStoreFraming_banner__pFu1T","icons":"InStoreFraming_icons__N9NIR","social":"InStoreFraming_social__obEaw"};